import { EyeOutlined, FormOutlined, SignatureFilled } from '@ant-design/icons';
import { EnumInfoDelegaTipo } from '@framework/api-client';
import { assertNever, expectNeverAsString } from '@framework/engine';
import { IDelegation } from '@framework/frontoffice-submission';
import { Tag, TagProps } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const StyledTag = styled(Tag)`
  /* text-transform: uppercase;
  letter-spacing: 0.03em; */
  font-size: 16px;
  .anticon {
    font-size: 0.9em;
    margin-right: 0.2em;
  }
  &&& {
    /* font-weight: 600; */
  }
`;

/**
 * Ritorna l'icona del tipo di delega
 *
 */
export function getDelegationTypeIcon(
  type?: EnumInfoDelegaTipo,
): React.ReactNode {
  if (!type) return null;
  switch (type) {
    case EnumInfoDelegaTipo.COMPILAZIONE:
      return <FormOutlined aria-hidden />;
    case EnumInfoDelegaTipo.VISUALIZZAZIONE:
      return <EyeOutlined aria-hidden />;
    case EnumInfoDelegaTipo.FIRMA:
      return <SignatureFilled aria-hidden />;
  }
  assertNever(type);
}

/**
 * Ritorna le impostazioni per il tag
 *
 */
function getTagOptions(
  delegate?: Partial<Pick<IDelegation, 'userName' | 'type'>> | undefined,
): TagProps {
  const type = delegate?.type;
  if (!type) return {};
  const children = (
    <span>
      {getDelegationTypeIcon(delegate.type)}
      {delegate.userName && ' ' + delegate.userName}
    </span>
  );
  switch (type) {
    case EnumInfoDelegaTipo.COMPILAZIONE:
      return {
        color: 'blue',
        bordered: false,
        children: children,
      };
    case EnumInfoDelegaTipo.VISUALIZZAZIONE:
      return {
        color: 'green',
        bordered: false,
        children: children,
      };
    case EnumInfoDelegaTipo.FIRMA:
      return {
        color: 'purple',
        bordered: false,
        children: children,
      };

    default:
      return { children: expectNeverAsString(type) };
  }
}

export interface DelegationTypeUserTagProps {
  delegate?: Partial<Pick<IDelegation, 'userName' | 'type'>> | null;
}

/**
 * Tag di un utente delegato
 */
export function DelegationTypeUserTag(props: DelegationTypeUserTagProps) {
  const { delegate } = props;
  if (!delegate) return null;

  return <StyledTag {...getTagOptions(delegate)} />;
}
